import { observer } from 'mobx-react'

import centsToDecimal from 'modules/core/lib/formatCents'
import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  joursInCents?: number
}

const JoursParAn = ({ joursInCents }: Props) => {
  const description = joursInCents ? centsToDecimal(joursInCents) : undefined
  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.france.jours_par_an')}
      description={description?.toString()}
    />
  )
}

export default observer(JoursParAn)
